import { REFERRAL_STATUS_LABELS, type ReferralStatus } from '@wodi/domain';

// Status words and tag shapes for referrals (DESIGN.md §7: the word says the state, the
// shape tells states apart; no colour).

type TagState = 'pending' | 'active' | 'done' | 'attention' | 'failed' | 'neutral';

const SHAPES: Record<ReferralStatus, TagState> = {
  sent: 'pending',
  acknowledged: 'active',
  attended: 'done',
  received: 'pending',
  feedback_sent: 'done',
  closed: 'neutral',
  entered_in_error: 'neutral',
};

export function referralStatusTag(status: ReferralStatus): { state: TagState; word: string } {
  return { state: SHAPES[status], word: REFERRAL_STATUS_LABELS[status] };
}
